import { MobXProviderContext } from 'mobx-react';
import { useContext } from 'react';
import {
    TeacherStore,
    StudentStore,
    UserStore,
    RoomStore,
    BoardStore,
    DeviceStore,
    ScreenShareStore,
    AssistantStore,
    LoginStore,
    PermissionStore,
    CommodityStore,
    ThridStreamStore,
} from '@gaodun.com/g2-live-sdk';
import { LiveRoomStore } from '@/store';
export type appContext = Record<string, LiveRoomStore>;

export const useAppStore = (): LiveRoomStore => {
    const context = useContext<appContext>(MobXProviderContext);
    return context.store;
};

export const useRoomStore = (): RoomStore => {
    const context = useContext<appContext>(MobXProviderContext);
    return context.store.roomStore;
};

export const useUserStore = (): UserStore => {
    const context = useContext<appContext>(MobXProviderContext);
    return context.store.userStore;
};

export const useStudentStore = (): StudentStore | undefined => {
    const context = useContext<appContext>(MobXProviderContext);
    return context.store.studentStore;
};

export const useTeacherStore = (): TeacherStore | undefined => {
    const context = useContext<appContext>(MobXProviderContext);
    return context.store.teacherStore;
};

export const useBoardStore = (): BoardStore => {
    const context = useContext<appContext>(MobXProviderContext);
    return context.store.boardStore;
};

export const useDeviceStore = (): DeviceStore => {
    const context = useContext<appContext>(MobXProviderContext);
    return context.store.deviceStore;
};

export const useScreenShareStore = (): ScreenShareStore => {
    const context = useContext<appContext>(MobXProviderContext);
    return context.store.screenShareStore;
};

export const useAssistantStore = (): AssistantStore | undefined => {
    const context = useContext<appContext>(MobXProviderContext);
    return context.store.assistantStore;
};

export const useLoginStore = (): LoginStore | undefined => {
    const context = useContext<appContext>(MobXProviderContext);
    return context.store.loginStore;
};

export const usePermissionStore = (): PermissionStore | undefined => {
    const context = useContext<appContext>(MobXProviderContext);
    return context.store.permissionStore;
};

export const useCommodityStore = (): CommodityStore => {
    const context = useContext<appContext>(MobXProviderContext);
    return context.store.commodityStore;
};

export const useThridStreamStore = (): ThridStreamStore | undefined => {
    const context = useContext<appContext>(MobXProviderContext);
    return context.store.thridStreamStore;
};

export { useZIndex } from './useZIndex';
